import React, { useMemo } from 'react';
import { fillTemplate } from '../lib/mailto';

function CopyField({ label, value, onCopy }) {
  const handle = async () => {
    try {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        await navigator.clipboard.writeText(value);
      } else {
        const ta = document.createElement('textarea');
        ta.value = value; document.body.appendChild(ta); ta.select();
        document.execCommand('copy'); document.body.removeChild(ta);
      }
      onCopy && onCopy(label);
    } catch {
      onCopy && onCopy(null);
    }
  };
  return (
    <div className="stack">
      <label className="label">{label}</label>
      <div className="row" style={{ alignItems: 'stretch' }}>
        <textarea readOnly className="input" rows={label === 'Body' ? 6 : 1} value={value} />
      </div>
      <button className="btn secondary" onClick={handle}>Copy {label.toLowerCase()}</button>
    </div>
  );
}

export default function MailtoFallback({ lender, firstName, bcc, templates, onMarkSent, onBack, showToast }) {
  const vars = useMemo(() => ({
    client_name: firstName || '',
    first_name: firstName || '',
    lender_name: lender.lenderName,
    agreement_number: lender.agreementNumber || '',
  }), [firstName, lender]);

  const subject = fillTemplate(templates?.perLenderSubject, vars) || `Request to remain represented by Fair — ${lender.lenderName}`;
  const body = fillTemplate(templates?.perLenderBody, vars) ||
    `Dear ${lender.lenderName},\n\nI confirm that I wish to remain represented by Fair Inc for my claim${lender.agreementNumber ? ` under agreement ${lender.agreementNumber}` : ''}.\n\nPlease continue to direct correspondence to Fair.\n\nKind regards,\n${firstName || ''}`;

  const onCopy = (label) => {
    if (label) showToast(`Copied ${label.toLowerCase()}`);
    else showToast('Copy failed — long-press the field');
  };

  return (
    <div className="card stack-lg">
      <h2 className="h2">No problem — copy and send manually</h2>
      <p className="muted">Open your email app, paste these three fields, then come back and mark as sent.</p>

      <CopyField label="To" value={lender.lenderEmail} onCopy={onCopy} />
      <CopyField label="Subject" value={subject} onCopy={onCopy} />
      <CopyField label="Body" value={body} onCopy={onCopy} />
      {bcc ? <CopyField label="BCC" value={bcc} onCopy={onCopy} /> : null}

      <button className="btn full" onClick={onMarkSent}>I've sent it manually — mark as sent</button>
      <button className="btn ghost" onClick={onBack}>Try the email button again</button>
    </div>
  );
}
